const color = {
    50: '#FCE2B6',
    300: '#F9C56D',
    400: '#F7B13C',
    500: '#F59E0B',
    700: '#DD8E0A',
    900: '#C47E09'
};
export default color;
